/**
 * Feature Flags configuration.
 *
 * This file provides a centralized way to manage feature toggles.
 * To satisfy the requirement of only applying changes to the "tonic3" brand,
 * the flags use a getter that checks the current URL path.
 */

const getBrandSlugFromUrl = () => {
	const path = window.location.pathname;
	const parts = path.split('/');
	// The brand slug is expected to be the first segment after the domain: /:brandSlug/...
	return parts[1] || '';
};

// Global toggle for Points and Rewards feature (set to false to hide for targeted brands)
const GLOBAL_ENABLE_POINTS_AND_REWARDS = false;

export const FEATURE_FLAGS = {
	get ENABLE_POINTS_AND_REWARDS() {
		const brandSlug = getBrandSlugFromUrl();
		// Only apply the disabling change when brandSlug is "tonic3"
		if (brandSlug === 'tonic3') {
			return GLOBAL_ENABLE_POINTS_AND_REWARDS;
		}
		// For all other brands, points and rewards remain enabled
		return true;
	},
};
